import "./style.css";

export default class Pagination {
  static selector = ".s-pagination";

  constructor(block) {
    this.block = block;
  }

  onClick(index) {
    const $oldActive = this.block.querySelector(
      ".s-pagination__item-number.h1"
    );
    $oldActive.classList.remove("h1");
    $oldActive.classList.add("h3");

    const $active = this.$items[index];
    $active.classList.remove("h3");
    $active.classList.add("h1");

    const { callback } = this.block;
    if (callback) callback(index);
  }

  init() {
    this.$items = this.block.querySelectorAll(".s-pagination__item-number");
    this.$items.forEach(($el, index) => {
      $el.addEventListener("click", () => {
        this.onClick(index);
      });
    });
  }

  onReady() {
    this.init();
  }
}
